<template>
    <v-container>
        <v-layout>
            <v-flex xs12 sm10 offset-sm1 lg6 offset-lg3>
                <v-card>
                    <v-card-title primary-title>
                        <div>
                            <h3 class="headline mb-0" v-t="'title.activate_account'"></h3>
                        </div>
                    </v-card-title>

                    <v-card-text class="text--primary" v-if="!success">
                        <v-alert :value="true" type="error" v-for="error in errors" :key="error">{{
                            $t(`error.${error}`)
                        }}</v-alert>
                        <v-progress-circular
                            :size="100"
                            color="primary"
                            indeterminate
                            v-if="loading"
                        ></v-progress-circular>
                    </v-card-text>
                    <v-card-text class="text--primary" v-else>
                        <p class="title text-xs-center" v-t="'message.email_validated'"></p>
                        <div class="text-xs-center">
                            <v-btn
                                :to="{ name: 'login' }"
                                v-t="'button.login'"
                                color="primary"
                                outlined
                            ></v-btn>
                        </div>
                    </v-card-text>
                </v-card>
                <v-card class="text-xs-center"></v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
import loadingMixin from "@/mixins/loading"
export default {
    mixins: [loadingMixin],
    data() {
        return {
            valid: false,
            success: false,
            errors: [],
        }
    },
    mounted() {
        this.activate()
    },
    methods: {
        async activate() {
            this.loading = true
            this.errors = []
            try {
                const {
                    data: { confirmNewEmail },
                    errors,
                } = await this.$apollo.mutate({
                    mutation: require("@/graphql/account/confirmNewEmail.gql"),
                    variables: {
                        token: this.$route.params.token,
                    },
                })

                if (!confirmNewEmail) {
                    this.errors = confirmNewEmail.errors
                } else {
                    this.success = true
                }
            } catch (error) {
                this.errors = error.graphQLErrors.map((e) => e.message)
            }
            this.loading = false
        },
    },
}
</script>
